export const IS_BETA = process.env.REACT_APP_IS_BETA === "true";
export const IS_CHAT_ENABLED = process.env.REACT_APP_IS_CHAT_ENABLED === "true" ;
export const IS_PRODUCTION = process.env.REACT_APP_NODE_ENV === "production";
export const IS_DEVELOPMENT = process.env.REACT_APP_NODE_ENV === "development";
// Players pick the game's language on beta only. The play (live) build is English only: it shows no
// language picker and ignores the browser's language and any saved choice.
export const LANGUAGE_SWITCHING = IS_BETA;
